// src/components/GameTopBar.jsx
//
// The in-game top bar for EVERY game (NTG Sr., NTG Jr., NFL/NBA/Mosh dailies,
// Guy Off). One component so the KYG mark and HOME button can't drift in size
// or position between games.
//
// Layout: subtle KYG mark hard left, HOME button hard right.

import React from 'react';

export default function GameTopBar({ onGoHome }) {
  return (
    <div className="game-top-bar">
      <span className="game-brand-mark">
        KYG<sup className="game-brand-tm">™</sup>
      </span>
      <button className="btn-home-small" onClick={onGoHome}>HOME</button>
    </div>
  );
}
